import React from 'react'
import styled from 'styled-components'
import BackgroundPicture from 'components/assets/login-picture.png'

import { LoginLogo } from 'brand'
import LoginForm from './LoginForm'

export default function Login() {
  return (
    <Container>
      <Content>
        <Header>
          <LoginLogo />
        </Header>
        <LoginForm />
      </Content>
      <Image />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  min-height: 100vh;
`
const Header = styled.div`
  height: 285px;
  background: #f0f8ff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const Content = styled.div`
  width: 400px;
`

const Image = styled.div`
  background-image: url(${BackgroundPicture});
  background-size: cover;
  flex: 1;
`
